import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { useCreateZoneServiceItemMutation } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

interface UseZoneServiceItemsFormManagerProps {
  zoneId: number;
  next?: (data?: any) => void;
}

export const useZoneServiceItemsFormManager = ({ zoneId, next = () => {} }: UseZoneServiceItemsFormManagerProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [mutate, { isLoading, isSuccess, isError, ...rest }] = useCreateZoneServiceItemMutation();

  const initialValues = {
    name: '',
  };

  const validationSchema = Yup.object({
    name: Yup.string().nullable().required('This value is required.'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (serviceItem, { resetForm }) => {
      resetForm({});

      mutate({
        orgSlug,
        zoneId,
        serviceItem,
      });
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      const { data } = rest;

      next(data);
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading: isLoading,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading: boolean;
    },
  ];
};
